import poiIcon from '@atom/components/common/svgIcons/googlePlaces.svg';
import poiActiveIcon from '@atom/components/common/svgIcons/googlePlacesActive.svg';
import {
  MapIcon,
  SatelliteIcon,
  TerrainIcon,
  TrafficIcon,
} from '@atom/mui/icons';

import { useAtomMap } from '../AtomMapProvider';

import MapControl from './MapControl';

import classes from './toolbar.module.css';

const LayerControls = () => {
  const { preferences, dispatch } = useAtomMap();

  return (
    <div className={classes.layerControls} data-cy="atomMapLayerControls">
      <div className={classes.layerIcon}>
        <MapControl
          icon={SatelliteIcon}
          tooltip="Satellite"
          active={preferences.mapTypeId === 'hybrid'}
          onClick={() =>
            dispatch({ type: 'SET_MAP_TYPE', mapTypeId: 'hybrid' })
          }
          dataCy="atomMapSatelliteButton"
        />
      </div>
      <div className={classes.layerIcon}>
        <MapControl
          icon={MapIcon}
          tooltip="Map"
          active={preferences.mapTypeId === 'roadmap'}
          onClick={() =>
            dispatch({ type: 'SET_MAP_TYPE', mapTypeId: 'roadmap' })
          }
          dataCy="atomMapMapButton"
        />
      </div>
      <div className={classes.layerIcon}>
        <MapControl
          icon={TerrainIcon}
          tooltip="Terrain"
          active={preferences.mapTypeId === 'terrain'}
          onClick={() =>
            dispatch({ type: 'SET_MAP_TYPE', mapTypeId: 'terrain' })
          }
          dataCy="atomMapTerrainButton"
        />
      </div>
      <div className={classes.layerIcon}>
        <MapControl
          icon={TrafficIcon}
          tooltip="Traffic"
          active={preferences.traffic}
          onClick={() =>
            dispatch({ type: 'SET_TRAFFIC', traffic: !preferences.traffic })
          }
          dataCy="atomMapTrafficButton"
        />
      </div>
      <div className={classes.layerIcon}>
        <MapControl
          icon={<img src={preferences.poi ? poiActiveIcon : poiIcon} />}
          tooltip="Google Places"
          active={preferences.poi}
          onClick={() => dispatch({ type: 'SET_POI', poi: !preferences.poi })}
          dataCy="atomMapGooglePlacesButton"
        />
      </div>
    </div>
  );
};

export default LayerControls;
